export enum PluralForm {
  One = 'one',
  Other = 'other',
}
